import { render, staticRenderFns } from "./CategorySearchCom.vue?vue&type=template&id=0571f9b4&scoped=true"
import script from "./CategorySearchCom.vue?vue&type=script&lang=js"
export * from "./CategorySearchCom.vue?vue&type=script&lang=js"
import style0 from "./CategorySearchCom.vue?vue&type=style&index=0&id=0571f9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0571f9b4",
  null
  
)

export default component.exports